module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Gamepad2-60943d5f0d5ea32a41f72c857ef46bcd.svg";